module.exports = __webpack_public_path__ + "img/1.c725d9d2.jpg";